import { gql } from '@apollo/client'

export const GET_USER_FORM_SUBMISSION_QUERY = gql`
  query UserFormSubmission($formTemplateId: String!) {
    activeFormSubmissionForUser(formTemplateId: $formTemplateId) {
      id
      formTemplateId
      submissionData
      status
      submissionType
      submittedAt
      archivedAt
    }
  }
`

export const CREATE_FORM_SUBMISSION_MUTATION = gql`
  mutation CreateFormSubmission($input: CreateFormSubmissionInput!) {
    createFormSubmission(input: $input) {
      id
      submittedAt
    }
  }
`

export const UPDATE_FORM_SUBMISSION_MUTATION = gql`
  mutation UpdateFormSubmission(
    $id: String!
    $input: UpdateFormSubmissionInput!
  ) {
    updateFormSubmission(id: $id, input: $input) {
      id
      submittedAt
      submissionData
      status
    }
  }
`
